import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Crosshair, LogOut, ShieldCheck, User } from "lucide-react";

const LOGO = "https://customer-assets-jt897jd0.emergentagent.net/job_c1e88c9c-ba91-434a-98cf-46a301cc1400/artifacts/0ga5g2nx_Gemini_Generated_Image_x16783x16783x167-removebg-preview.png";

const links = [
  { to: "/", label: "Home" },
  { to: "/standings", label: "Standings" },
  { to: "/schedule", label: "Schedule" },
  { to: "/syndicates", label: "Syndicates" },
  { to: "/stats", label: "Stats" },
];

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const authed = user && typeof user === "object";
  const role = authed ? user.role : null;

  return (
    <header className="sticky top-0 z-40 border-b border-surface-line bg-void/85 backdrop-blur">
      <div className="max-w-7xl mx-auto px-4 md:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3">
          <img src={LOGO} alt="RTRL" className="w-10 h-10 object-contain drop-shadow-[0_0_10px_rgba(229,25,25,0.5)]" />
          <div className="leading-none">
            <div className="font-display text-2xl uppercase tracking-widest text-white">RTRL</div>
            <div className="small-label -mt-1">Red Target Racing League</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              end={l.to === "/"}
              className={({ isActive }) =>
                `px-4 py-2 uppercase text-sm tracking-widest font-body ${isActive ? "text-rtrl-red border-b-2 border-rtrl-red" : "text-white/70 hover:text-white"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
          {authed && (role === "syndicate_owner" || role === "gm" || role === "admin" || role === "moderator") && (
            <NavLink to="/team-admin" data-testid="nav-team-admin"
              className={({ isActive }) => `px-4 py-2 uppercase text-sm tracking-widest font-body ${isActive ? "text-rtrl-red border-b-2 border-rtrl-red" : "text-white/70 hover:text-white"}`}>
              Team
            </NavLink>
          )}
          {role === "admin" && (
            <NavLink to="/admin" data-testid="nav-admin"
              className={({ isActive }) => `px-4 py-2 uppercase text-sm tracking-widest font-body flex items-center gap-1 ${isActive ? "text-rtrl-red border-b-2 border-rtrl-red" : "text-white/70 hover:text-white"}`}>
              <ShieldCheck className="w-4 h-4" /> Admin
            </NavLink>
          )}
        </nav>

        <div className="flex items-center gap-2">
          {!authed ? (
            <>
              <Link to="/login" data-testid="nav-login" className="rtrl-btn-ghost hidden sm:inline-flex">Log In</Link>
              <Link to="/register" data-testid="nav-register" className="rtrl-btn">
                <Crosshair className="w-4 h-4" /> Register
              </Link>
            </>
          ) : (
            <>
              <Link to="/profile" data-testid="nav-profile" className="rtrl-btn-ghost hidden sm:inline-flex">
                <User className="w-4 h-4" /> {user.display_name?.split(" ")[0] || "Profile"}
              </Link>
              <button data-testid="nav-logout" onClick={() => { logout(); nav("/"); }} className="rtrl-btn-ghost">
                <LogOut className="w-4 h-4" /> Sign out
              </button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
